import { render, staticRenderFns } from "./rightSetDetail.vue?vue&type=template&id=8682910c&scoped=true&"
import script from "./rightSetDetail.vue?vue&type=script&lang=js&"
export * from "./rightSetDetail.vue?vue&type=script&lang=js&"
import style0 from "./rightSetDetail.vue?vue&type=style&index=0&id=8682910c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8682910c",
  null
  
)

export default component.exports